import { useWhiteLabel } from "../contexts/WhiteLabelContext";
import { useState } from "react";

// Hook to get white label button styles
export const useWhiteLabelStyles = () => {
  const { primaryColor, isWhiteLabel } = useWhiteLabel();

  const getButtonStyle = (
    type: "primary" | "secondary" = "primary",
    isHovered: boolean = false
  ) => {
    if (!isWhiteLabel) {
      return {}; // Use default Tailwind classes
    }

    if (type === "primary") {
      const baseStyle = {
        backgroundColor: primaryColor,
        borderColor: primaryColor,
        "--tw-ring-color": primaryColor,
        color: "white",
      };

      if (isHovered) {
        return {
          ...baseStyle,
          filter: "brightness(0.9)",
        };
      }

      return baseStyle;
    } else {
      if (isHovered) {
        return {
          backgroundColor: primaryColor,
          borderColor: primaryColor,
          color: "white",
        };
      }
      return {
        borderColor: primaryColor,
        color: primaryColor,
        backgroundColor: "transparent",
      };
    }
  };

  // const getHoverStyle = (type: "primary" | "secondary" = "primary") => {
  //   if (!isWhiteLabel) {
  //     return {};
  //   }

  //   if (type === "primary") {
  //     // Darken the primary color on hover
  //     return {
  //       filter: "brightness(0.9)",
  //     };
  //   } else {
  //     return {
  //       backgroundColor: primaryColor,
  //       color: "white",
  //     };
  //   }
  // };

  const getPrimaryButtonClasses = () => {
    return isWhiteLabel
      ? "text-white font-medium rounded-md transition-all duration-200 ease-in-out"
      : "bg-blue-600 text-white hover:bg-blue-700 font-medium rounded-md transition-colors duration-200";
  };

  const getSecondaryButtonClasses = () => {
    return isWhiteLabel
      ? "border font-medium rounded-md transition-all duration-200 ease-in-out"
      : "border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium rounded-md transition-colors duration-200";
  };

  return {
    getButtonStyle,
    // getHoverStyle,
    getPrimaryButtonClasses,
    getSecondaryButtonClasses,
    primaryColor,
    isWhiteLabel,
  };
};

// Component wrapper for buttons with white label styling
interface WhiteLabelButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
  children: React.ReactNode;
}

export const WhiteLabelButton: React.FC<WhiteLabelButtonProps> = ({
  variant = "primary",
  className = "",
  style,
  children,
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const {
    getButtonStyle,
    // getHoverStyle,
    getPrimaryButtonClasses,
    getSecondaryButtonClasses,
  } = useWhiteLabelStyles();

  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Object.assign(e.currentTarget.style, getHoverStyle(variant));
    setIsHovered(true);
    onMouseEnter?.(e);
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Object.assign(e.currentTarget.style, getButtonStyle(variant));
    setIsHovered(false);
    onMouseLeave?.(e);
  };

  const baseClasses =
    variant === "primary"
      ? getPrimaryButtonClasses()
      : getSecondaryButtonClasses();

  const buttonStyle = {
    ...getButtonStyle(variant, isHovered),
    ...style,
  };

  return (
    <button
      className={`${baseClasses} ${className}`}
      style={buttonStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
    </button>
  );
};
